<template>
  <el-dialog
    class="dialog-filter"
    title="筛选"
    width="1010px"
    v-bind="$attrs"
    v-on="$listeners"
    top="10vh"
    @open="onDialogOpen"
  >
    <div class="filter-wrapper">
      <div class="filter-left">
        <!-- 车主 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">车主</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.source" @change="onSourceChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in sources" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl>
        <!-- 月供 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">月供</span>
          </dt>
          <dd class="filter-item">
            <div class="filter-input__list">
              <el-input-number
                class="filter-input__item"
                placeholder="月供最低"
                :min="0"
                :precision="0"
                :max="9999999"
                :controls="false"
                v-model="form.minMonthlySupply"
              >
              </el-input-number>
              <div class="filter-input__separator"></div>
              <el-input-number
                class="filter-input__item"
                placeholder="月供最高"
                :min="0"
                :precision="0"
                :max="9999999"
                :controls="false"
                v-model="form.maxMonthlySupply"
              >
              </el-input-number>
            </div>
          </dd>
        </dl>
        <!-- 首付 -->
        <!-- <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">首付</span>
          </dt>
          <dd class="filter-item">
            <div class="filter-input__list">
              <el-input-number
                class="filter-input__item"
                placeholder="首付最低"
                :min="0"
                :precision="0"
                :max="9999999"
                :controls="false"
                v-model="form.minDownPayments"
              >
              </el-input-number>
              <div class="filter-input__separator"></div>
              <el-input-number
                class="filter-input__item"
                placeholder="首付最高"
                :min="0"
                :precision="0"
                :max="9999999"
                :controls="false"
                v-model="form.maxDownPayments"
              >
              </el-input-number>
            </div>
          </dd>
        </dl> -->
        <!-- 剩余月数 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">剩余月数</span>
            <span class="filter-header__tip">(单位：月)</span>
          </dt>
          <dd class="filter-item">
            <div class="filter-slider__tip">
              <span>{{ lastTimeOptions.minLabel }}</span>
              <span>{{ lastTimeOptions.maxLabel }}</span>
            </div>
            <el-slider
              class="filter-slider"
              v-model="form.lastTime"
              range
              :min="lastTimeOptions.min"
              :max="lastTimeOptions.max"
              :step="lastTimeOptions.step"
              :format-tooltip="lastTimeFormat"
            ></el-slider>
          </dd>
        </dl>
        <!-- 剩余公里数 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">剩余公里数</span>
            <span class="filter-header__tip">(单位：万km)</span>
          </dt>
          <dd class="filter-item">
            <div class="filter-slider__tip">
              <span>{{ remainingKMOptions.minLabel }}</span>
              <span>{{ remainingKMOptions.maxLabel }}</span>
            </div>
            <el-slider
              class="filter-slider"
              v-model="form.remainingKM"
              range
              :min="remainingKMOptions.min"
              :max="remainingKMOptions.max"
              :step="remainingKMOptions.step"
              :format-tooltip="remainingKMFormat"
            ></el-slider>
          </dd>
        </dl>
        <!-- 现有公里数 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">现公里数</span>
            <span class="filter-header__tip">(单位：万km)</span>
          </dt>
          <dd class="filter-item">
            <div class="filter-slider__tip">
              <span>{{ existingKMOptions.minLabel }}</span>
              <span>{{ existingKMOptions.maxLabel }}</span>
            </div>
            <el-slider
              class="filter-slider"
              v-model="form.existingKM"
              range
              :min="existingKMOptions.min"
              :max="existingKMOptions.max"
              :step="existingKMOptions.step"
              :format-tooltip="existingKMFormat"
            ></el-slider>
          </dd>
        </dl>
        <!-- 标签 -->
        <!-- <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">标签</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.tags" @change="onTagsChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in tags" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl> -->
      </div>



      <div class="filter-right">
        <!-- 车型 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">车型</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.mould" @change="onMouldChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in moulds" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl>
        <!-- 能源 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">能源</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.fuelType" @change="onFuelTypeChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in fuelTypes" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl>
        <!-- 变速箱 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">变速箱</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.gearBox" @change="onGearBoxChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in gearBoxs" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl>
        
        <!-- 驱动 -->
        <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">驱动</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.drivingType" @change="onDrivingTypeChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in drivingTypes" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl>
        <!-- 配置选项 -->
        <!-- <dl class="filter-section">
          <dt class="filter-header">
            <span class="filter-header__name">配置选项</span>
          </dt>
          <dd class="filter-item">
            <el-checkbox-group class="filter-checkbox__list" v-model="form.config" @change="onConfigChange">
              <el-checkbox class="filter-checkbox__item" v-for="item in configs" :key="item.id" :label="item">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </dd>
        </dl> -->
      </div>
    </div>
    <div class="filter-button__list" slot="footer">
      <el-button class="filter-button__item" type="text" @click="resetOptions">
        <i class="el-icon-refresh-right"></i>
        <span>重置</span>
      </el-button>
      <el-button class="filter-button__item" type="danger" @click="submitOptions">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  sources,
  gearBoxs,
  fuelTypes,
  drivingTypes,
  lastTimeOptions,
  remainingKMOptions,
  existingKMOptions,
} from '../components/data';
export default {
  name: 'DialogFilter',
  // data 和 this.form 数据结构一致
  props: { data: Object },
  data() {
    return {
      // 车主身份列表
      sources,
      // 车型列表
      moulds: [],
      // 标签列表
      tags: [],
      // 变速箱列表
      gearBoxs,
      // 能源类型列表
      fuelTypes,
      // 驱动类型列表
      drivingTypes,
      // 配置列表
      configs: [],

      // 剩余月数配置
      lastTimeOptions,
      // 剩余公里数配置
      remainingKMOptions,
      // 现有公里数配置
      existingKMOptions,
      // 表单
      form: {
        // 车主
        source: [],
        // 最低月供
        minMonthlySupply: undefined,
        // 最高月供
        maxMonthlySupply: undefined,
        // 最低首付
        minDownPayments: undefined,
        // 最高首付
        maxDownPayments: undefined,
        // 剩余月份
        lastTime: [lastTimeOptions.min, lastTimeOptions.max],
        // 剩余公里数
        remainingKM: [remainingKMOptions.min, remainingKMOptions.max],
        // 现有公里数，现在已经开了多少公里，单位km
        existingKM: [existingKMOptions.min, existingKMOptions.max],

        // 车型
        mould: [],
        // 标签：可邮寄等预定义标签
        tags: [],
        // 变速箱类型 1手动 2自动
        gearBox: [],
        // 燃油类型，1汽车，2柴油，3电动 4油电混合
        fuelType: [],
        // 驱动类型 1前驱；2后驱；3四驱；4全驱；
        drivingType: [],
        // 配置，支持多个
        config: [],
      },
    };
  },
  created() {
    this.getMoulds();
    this.getTags();
    this.getConfigs();
  },
  methods: {
    /**
     * 提交筛选条件
     */
    submitOptions() {
      const { minMonthlySupply, maxMonthlySupply, minDownPayments, maxDownPayments } = this.form;
      if (minMonthlySupply && maxMonthlySupply && minMonthlySupply > maxMonthlySupply)
        return this.$warning('月供最低值不能大于最高值');

      if (minDownPayments && maxDownPayments && minDownPayments > maxDownPayments)
        return this.$warning('首付最低值不能大于最高值');

      this.$emit('change', this.form);
      this.$emit('update:visible', false);
    },
    /**
     * 重置筛选条件
     */
    resetOptions() {
      Object.assign(this.form, this.$options.data().form);
      this.$emit('change', this.form);
      this.$emit('update:visible', false);
    },
    /**
     * 打开对话框时
     */
    onDialogOpen() {
      const form = { ...this.form, ...this.data };

      this.form = form;
    },
    /**
     * 车主身份发生变化
     */
    onSourceChange(vals) {
      this.form.source = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.sources[0]];
    },
    /**
     * 车型发生变化
     */
    onMouldChange(vals) {
      this.form.mould = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.moulds[0]];
    },
    /**
     * 标签发生变化
     */
    onTagsChange(vals) {
      this.form.tags = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.tags[0]];
    },
    /**
     * 变速箱类型发生变化
     */
    onGearBoxChange(vals) {
      this.form.gearBox = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.gearBoxs[0]];
    },
    /**
     * 能源类型发生变化
     */
    onFuelTypeChange(vals) {
      this.form.fuelType = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.fuelTypes[0]];
    },
    /**
     * 驱动类型发生变化
     */
    onDrivingTypeChange(vals) {
      this.form.drivingType = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.drivingTypes[0]];
    },
    /**
     * 配置选项发生变化
     */
    onConfigChange(vals) {
      this.form.config = vals.length
        ? vals.filter(item => (vals[vals.length - 1]['id'] === 0 ? item.id === 0 : item.id !== 0))
        : [this.configs[0]];
    },
    /**
     * 剩余月数tip格式化
     */
    lastTimeFormat(val) {
      return val === lastTimeOptions.max ? lastTimeOptions.maxLabel : val + '';
    },
    /**
     * 剩余公里数tip格式化
     */
    remainingKMFormat(val) {
      return val === remainingKMOptions.max ? remainingKMOptions.maxLabel : val + '';
    },
    /**
     * 现有公里数tip格式化
     */
    existingKMFormat(val) {
      return val === existingKMOptions.max ? existingKMOptions.maxLabel : val + '';
    },
    /**
     * 获取车型列表
     */
    async getMoulds() {
      const { data } = await this.$axios.post('/car/v1/get/mould/list');
      this.moulds = [{ id: 0, name: '不限' }, ...(data || [])];
    },
    /**
     * 获取标签列表
     */
    async getTags() {
      const { data } = await this.$axios.get('/car/v1/get/tag/tree');
      this.tags = [{ id: 0, name: '不限' }, ...(data.tag || [])];
    },
    /**
     * 获取汽车配置列表
     */
    async getConfigs() {
      const { data } = await this.$axios.post('/car/v1/get/configuration/list');
      this.configs = [{ id: 0, name: '不限' }, ...(data || [])];
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-filter {
  ::v-deep {
    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
      padding-left: 40px;
      padding-right: 50px;
    }
    .el-dialog__header {
      padding-top: 24px;
      padding-bottom: 18px;
    }
    .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
      max-height: 60vh;
      overflow-y: auto;
    }
    .el-dialog__footer {
      padding-top: 30px;
      padding-bottom: 30px;
    }
    .el-dialog__headerbtn {
      right: 50px;
      top: 28px;
    }
  }
}
.filter-wrapper {
  display: flex;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding-top: 15px;
  padding-bottom: 20px;
}
.filter-left,
.filter-right {
  width: 50%;
  box-sizing: border-box;
}
.filter-left {
  padding-right: 30px;
}
.filter-right {
  padding-left: 30px;
  border-left: 1px solid #d8d8d8;
}
.filter-header {
  margin-bottom: 10px;
  line-height: 20px;
}
.filter-header__name {
  font-size: 14px;
  color: var(--text-color-3);
  margin-right: 5px;
}
.filter-header__tip {
  font-size: 12px;
  color: var(--text-color-9);
}

.filter-input__list {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.filter-input__item {
  width: 100px;
  font-size: 14px;
  ::v-deep {
    .el-input__inner {
      text-align: start;
      border: 0 none;
      background: #f6f6f6;
      border-radius: 4px;
      height: 34px;
      line-height: 34px;
    }
  }
}
.filter-input__separator,
.filter-date__separator {
  width: 20px;
  height: 1px;
  background: #d8d8d8;
  margin: 0 10px;
}
.filter-button__list {
  display: flex;
  justify-content: flex-end;
}
.filter-button__item {
  padding: 0;
  width: 80px;
  height: 30px;
  &.el-button--text {
    color: var(--text-color-6);
  }
}
.filter-checkbox__list {
  display: flex;
  flex-wrap: wrap;
}
.filter-checkbox__item {
  width: 84px;
  height: 34px;
  background: #f6f6f6;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  color: var(--text-color-3);
  margin-bottom: 20px;
  ::v-deep {
    .el-checkbox__input {
      display: none;
    }
    .el-checkbox__label {
      padding-left: 0;
      color: inherit;
    }
  }
  &.is-checked {
    background-color: rgba(228, 58, 58, 0.1);
    color: var(--primary-color);
  }
}
.filter-date__list {
  display: flex;
  align-items: center;
}
.filter-date__item {
  width: 130px;
  ::v-deep {
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border: 0 none;
      background: #f6f6f6;
      padding-right: 25px;
    }
    .el-input__icon {
      line-height: 34px;
    }
  }
}
.filter-date__checkbox {
  margin-left: 20px;
}
.filter-slider {
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 20px;
  ::v-deep {
    .el-slider__runway {
      height: 2px;
    }
    .el-slider__bar {
      height: 2px;
    }
    .el-slider__button-wrapper {
      width: 30px;
      height: 30px;
    }
    .el-slider__button {
      box-sizing: border-box;
    }
  }
}
.filter-slider__tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  span {
    width: 30px;
    text-align: center;
  }
}
</style>
